import api from './api'

export const clientService = {
  getClients: (filters: any) => api.get('/clientes', { params: filters }),
  getClientById: (id: number) => api.get(`/clientes/${id}`),
  createClient: (data: any) => api.post('/clientes', data),
  updateClient: (id: number, data: any) => api.put(`/clientes/${id}`, data),
  deleteClient: (id: number) => api.delete(`/clientes/${id}`),
  searchClients: (term: string) => api.get('/clientes/buscar', { params: { term } }),
  getClientContracts: (id: number) => api.get(`/clientes/${id}/contratos`),
}

export default clientService


